import { Agent } from '@sly/core/types';
import EntityTile from '@sly/frontend/react/card';
import { useState } from 'react';
import AgentTile from 'sly/agentsRegionPage/AgentsRegionPageContent/AgentsRegionPageData/AgentsRegionPageAgents/AgentTile';
import { isServer } from 'sly/config';
import { BoostedCommunity } from 'sly/hubPage/components/HubDynamicContent/ExploreByEntity/ExploreByCommunitySection/ExploreByCommunitySection.types';
import clsxm from 'sly/lib/clsxm';
import { usePrefetch } from 'sly/services/api';
import { Button } from 'sly/system';

import { TabListItem } from '..';
import { Entity } from '../ExploreByCommunity.types';

export default function ExploreByCommunitySection({
  active,
  tab,
  entity,
  serverRender = true,
}: {
  active: boolean;
  tab: TabListItem;
  entity: Entity;
  serverRender: boolean;
}) {
  const { slugs, title } = tab;
  const arrSlugs = slugs?.split(/\s+/) || [];

  const shouldBail = !serverRender && isServer;

  const { requestInfo } = usePrefetch(
    'getSearchPage',
    {
      'filter[id]': arrSlugs,
      include: 'community',
      exp: 'or',
      'page-size': arrSlugs.length,
    },
    { shouldBail: entity !== 'communities' || shouldBail }
  );

  // agents requestInfo
  const { requestInfo: agentsRequestInfo } = usePrefetch(
    'getAgentsNew',
    {
      'filter[slug]': arrSlugs.join(','),
      include: 'address,gallery,gallery.images',
      'page-size': arrSlugs.length,
    },
    { shouldBail: entity !== 'agents' || shouldBail }
  );

  const entityData: BoostedCommunity[] | Agent[] =
    entity === 'communities'
      ? requestInfo?.normalized
      : agentsRequestInfo?.normalized;

  const [showMore, setShowMore] = useState(false);
  const onClick = () => {
    setShowMore(!showMore);
  };
  return (
    <div
      className={clsxm(
        active ? '' : 'hidden',
        'w-fullmd:w-[720px] mx-auto mt-6 mb-20 lg:w-[1032px]'
      )}
    >
      <div className='mb-6 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3'>
        {entity === 'communities'
          ? entityData
              ?.slice(0, showMore ? undefined : 6)
              .map((community) => (
                <EntityTile
                  key={community.id}
                  entity={community}
                  intent='vertical'
                />
              ))
          : entityData
              ?.slice(0, showMore ? undefined : 6)
              .map((agent) => (
                <AgentTile agent={agent as Agent} key={agent.id} />
              ))}
      </div>
      {entityData?.length > 6 && (
        <Button
          className='mx-auto cursor-pointer border-black text-black'
          variant='outlined'
          onClick={onClick}
        >
          Show {showMore ? 'fewer' : 'more'} {title.toLowerCase()}
        </Button>
      )}
    </div>
  );
}
